import { Award, Briefcase, Globe, Clock } from "lucide-react";

const items = [
  { icon: Award, label: "Certifié Qualiopi" },
  { icon: Briefcase, label: "100% financé par votre CPF" },
  { icon: Globe, label: "100% en ligne & flexible" },
  { icon: Clock, label: "Réponse garantie sous 24h" },
];

const TrustBand = () => (
  <section className="trust-band py-6">
    <div className="container mx-auto grid grid-cols-2 gap-4 px-4 md:grid-cols-4 md:gap-8">
      {items.map((item) => (
        <div key={item.label} className="flex flex-col items-center gap-2 text-center text-primary-foreground">
          <item.icon className="h-7 w-7" />
          <span className="text-sm font-semibold">{item.label}</span>
        </div>
      ))}
    </div>
  </section>
);

export default TrustBand;
